import React from "react";
import "./Header.css"; // 添加样式文件

export const Header = (props) => {
  return (
    <header id="header" className="modern-header">
      <div className="header-background">
        <div className="gradient-overlay"></div>
      </div>
      
      <div className="header-content">
        <div className="content-container">
          <div className="text-content">
            <p className="hero-subtitle">Empowering the Future with AI</p>
            <h1 className="hero-title">
              AIで未来の<span className="common-sense">常識</span>を創る
            </h1>
            <p className="hero-description">
              最先端のAI技術と革新的なアプローチで、企業と社会の課題を根本から解決します。<br />
              私たちと共に、よりスマートで効率的な未来を築き、新しい常識を創造しましょう。
            </p>
            <div className="hero-buttons">
              <button 
                className="primary-button" 
                onClick={() => {
                  document.getElementById('our-services').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                ソリューション一覧 →
              </button>
              <button 
                className="secondary-button" 
                onClick={() => {
                  document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
                }}
              >
                無料相談を始める
              </button>
            </div>
          </div>
        </div>
        
        <div className="scroll-indicator">
          <p>スクロールして詳細を見る</p>
          <div className="scroll-arrow">↓</div>
        </div>
      </div>
    </header>
  );
};